import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/AuthContext';
import { getUserRole } from '../../utils/authUtils';

const SuperAdminRoute = ({ children }) => {
	const { state: authState } = useContext(AuthContext);
	// Wait for UserHydrator to populate the user object before evaluating role.
	// Render a spinner rather than null so hydration failures don't leave a blank screen.
	if (!authState.user) return (
		<div className="d-flex justify-content-center mt-5">
			<div className="spinner-border text-primary" role="status">
				<span className="visually-hidden">Loading…</span>
			</div>
		</div>
	);
	if (getUserRole(authState.user) !== 'SuperAdmin') {
		return <Navigate to="/home" replace />;
	}
	return children;
};

SuperAdminRoute.propTypes = {
	children: PropTypes.node.isRequired,
};

export default SuperAdminRoute;
